import {
  FiHome,
  FiBarChart2,
  FiUsers,
  FiLayers,
  FiShoppingCart,
  FiPieChart,
  FiTable,
  FiEdit,
  FiGrid,
  FiCalendar,
  FiChevronRight,
  FiSettings,
  FiUser,
  FiGift,
  FiUserCheck,
  FiLogOut,
  FiChevronDown,
  FiShield,
  FiBriefcase,
  FiActivity,
} from "react-icons/fi";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { TbMoneybag, TbTransactionRupee } from "react-icons/tb";
import { FiBox } from "react-icons/fi";
import { useAuth } from "../../context/AuthContext";
import { MdOutlineStackedBarChart } from "react-icons/md";

const Sidebar = ({ isOpen, onClose, isCollapsed }) => {
  const [openGroups, setOpenGroups] = useState({});
  const { user, logout, isSuperAdmin, isAdmin, isBackOffice, isAgent, hasPermission } = useAuth();

  const toggleGroup = (label) =>
    setOpenGroups((prev) => ({ ...prev, [label]: !prev[label] }));

  // Dynamic menu construction based on RBAC
  let currentMenu = [];

  if (isAgent) {
    currentMenu = [
      {
        label: "Agent Dashboard",
        icon: FiBox,
        to: "/agent/dashboard",
      },
      {
        label: "My Profile & Stats",
        icon: FiUser,
        to: user?.id ? `/collaborators/profile/${user.id}` : "/agent",
      },
      {
        label: "My Players",
        icon: FiUsers,
        to: user?.id ? `/collaborators/profile/${user.id}` : "/agent",
      },
    ];
  } else if (isBackOffice) {
    currentMenu = [
      { label: "Dashboard", icon: FiBox, to: "/" },
      ...(hasPermission("USERS_VIEW") ? [{ label: "Members", icon: FiUsers, to: "/users" }] : []),
      ...(hasPermission("AGENT_VIEW") ? [{ label: "Agents & Stores", icon: FiUsers, to: "/agent" }] : []),
      ...(hasPermission("DEPOSIT_VIEW") ? [{ label: "Recharge List", icon: TbMoneybag, to: "/recharge-list" }] : []),
      ...(hasPermission("WITHDRAWAL_VIEW") ? [{ label: "Withdrawal List", icon: FiShoppingCart, to: "/withdrawal-list" }] : []),
      ...(hasPermission("BONUS_VIEW") ? [{ label: "Bonus & Panelty History", icon: FiUsers, to: "/bonus-and-panelty-history" }] : []),
      ...(hasPermission("REPORT_VIEW") ? [{ label: "API Management", icon: FiLayers, to: "/api-management" }] : []),
    ];
  } else if (isSuperAdmin) {
    currentMenu = [
      { label: "Dashboard", icon: FiBox, to: "/" },
      { label: "Analytics", icon: MdOutlineStackedBarChart, to: "/analytics" },
      { label: "Admins", icon: FiShield, to: "/rbac/admins" },
      { label: "Back Office", icon: FiBriefcase, to: "/rbac/back-office" },
      { label: "Agents & Stores", icon: FiUsers, to: "/agent" },
      { label: "Members", icon: FiUsers, to: "/users" },
      { label: "Bonus & Panelty", icon: FiUsers, to: "/bonus-and-panelty" },
      { label: "Bonus & Panelty History", icon: FiUsers, to: "/bonus-and-panelty-history" },
      { label: "Recharge List", icon: TbMoneybag, to: "/recharge-list" },
      { label: "Withdrawal List", icon: FiShoppingCart, to: "/withdrawal-list" },
      { label: "Gift Codes", icon: FiGift, to: "/gift-codes" },
      { label: "Gift Used User", icon: FiGift, to: "/gift-used-user" },
      { label: "API Management", icon: FiLayers, to: "/api-management" },
      { label: "API Management New", icon: FiLayers, to: "/api-management-new" },
      { label: "Milestones", icon: FiLayers, to: "/milestones" },
      {
        label: "Settings",
        icon: FiSettings,
        children: [
          { label: "General Settings", to: "/settings/general" },
          { label: "Payment Methods", to: "/settings/payments" },
        ],
      },
      { label: "Roles & Permissions", icon: FiLayers, to: "/rbac/roles" },
      { label: "Audit Logs", icon: FiActivity, to: "/rbac/audit-logs" },
      { label: "Admin Profile", icon: FiUserCheck, to: "/admin" },
    ];
  } else {
    // ADMIN (Role Tier 2) - Configurable permissions
    currentMenu = [
      { label: "Dashboard", icon: FiBox, to: "/" },
      ...(hasPermission("ANALYTICS_VIEW") ? [{ label: "Analytics", icon: MdOutlineStackedBarChart, to: "/analytics" }] : []),
      ...(hasPermission("BACKOFFICE_VIEW") ? [{ label: "Back Office", icon: FiBriefcase, to: "/rbac/back-office" }] : []),
      ...(hasPermission("AGENT_VIEW") ? [{ label: "Agents & Stores", icon: FiUsers, to: "/agent" }] : []),
      ...(hasPermission("USERS_VIEW") ? [{ label: "Members", icon: FiUsers, to: "/users" }] : []),
      ...(hasPermission("BONUS_VIEW") ? [
        { label: "Bonus & Panelty", icon: FiUsers, to: "/bonus-and-panelty" },
        { label: "Bonus & Panelty History", icon: FiUsers, to: "/bonus-and-panelty-history" }
      ] : []),
      ...(hasPermission("DEPOSIT_VIEW") ? [{ label: "Recharge List", icon: TbMoneybag, to: "/recharge-list" }] : []),
      ...(hasPermission("WITHDRAWAL_VIEW") ? [{ label: "Withdrawal List", icon: FiShoppingCart, to: "/withdrawal-list" }] : []),
      { label: "Gift Codes", icon: FiGift, to: "/gift-codes" },
      { label: "Gift Used User", icon: FiGift, to: "/gift-used-user" },
      ...(hasPermission("REPORT_VIEW") ? [
        { label: "API Management", icon: FiLayers, to: "/api-management" },
        { label: "API Management New", icon: FiLayers, to: "/api-management-new" }
      ] : []),
      { label: "Milestones", icon: FiLayers, to: "/milestones" },
      ...(hasPermission("SYSTEM_SETTINGS_VIEW") ? [
        {
          label: "Settings",
          icon: FiSettings,
          children: [
            { label: "General Settings", to: "/settings/general" },
            { label: "Payment Methods", to: "/settings/payments" },
          ],
        }
      ] : []),
      ...(hasPermission("AUDIT_LOGS_VIEW") ? [{ label: "Audit Logs", icon: FiActivity, to: "/rbac/audit-logs" }] : []),
      { label: "Admin Profile", icon: FiUserCheck, to: "/admin" },
    ];
  }

  const roleDisplay = user?.role || "ADMIN";

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-20 md:hidden transition-opacity duration-200"
          onClick={onClose}
        />
      )}

      <aside
        className={`
          fixed z-30 inset-y-0 left-0 ${isCollapsed ? "md:w-20 w-72" : "w-72"} 
          bg-white
          border-r border-gray-200
          shadow-sm
          transform transition-all duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          md:static md:translate-x-0
          flex flex-col
        `}
      >
        {/* Logo Section */}
        <div className="h-16 flex items-center px-5 border-b border-gray-200 justify-between">
          <div className="flex items-center gap-3">
            <div className="relative flex-shrink-0">
              <div className="w-9 h-9 rounded-lg bg-emerald-600 flex items-center justify-center shadow-sm">
                <span className="text-white font-bold text-base">P</span>
              </div>
              <div className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-emerald-500 rounded-full border-2 border-white"></div>
            </div>
            {!isCollapsed && (
              <div>
                <h1 className="text-gray-900 font-bold text-base tracking-tight leading-none">
                  Ply<span className="text-emerald-600">Zoo</span>
                </h1>
                <p className="text-gray-400 text-[11px] font-medium mt-0.5">
                  {isAgent ? "Agent Portal" : isBackOffice ? "Back Office Portal" : "Admin Portal"}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Menu Navigation */}
        <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1 custom-scrollbar">
          {currentMenu.map((item) => {
            const Icon = item.icon;
            const hasChildren = !!item.children?.length;
            const isOpenGroup = openGroups[item.label];

            if (!hasChildren) {
              return (
                <NavLink
                  key={item.label}
                  to={item.to}
                  title={isCollapsed ? item.label : undefined}
                  className={({ isActive }) =>
                    `group flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive
                      ? "bg-gray-100 text-gray-900 font-semibold"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    }`
                  }
                  onClick={onClose}
                >
                  <Icon className="text-lg flex-shrink-0 text-gray-500 group-hover:text-gray-900 transition-colors" />
                  {!isCollapsed && <span className="truncate">{item.label}</span>}
                  {!isCollapsed && !hasChildren && (
                    <div className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity">
                      <FiChevronRight className="text-xs text-gray-400" />
                    </div>
                  )}
                </NavLink>
              );
            }

            return (
              <div key={item.label} className="space-y-1">
                <button
                  onClick={() => toggleGroup(item.label)}
                  title={isCollapsed ? item.label : undefined}
                  className={`group w-full flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm font-medium transition-colors ${isOpenGroup
                    ? "bg-gray-50 text-gray-900"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    }`}
                >
                  <Icon className="text-lg flex-shrink-0 text-gray-500 group-hover:text-gray-900 transition-colors" />
                  {!isCollapsed && (
                    <>
                      <span className="flex-1 text-left truncate">{item.label}</span>
                      <FiChevronDown
                        className={`text-xs text-gray-400 transition-transform duration-200 ${isOpenGroup ? "rotate-180" : ""
                          }`}
                      />
                    </>
                  )}
                </button>

                {!isCollapsed && isOpenGroup && (
                  <div className="ml-4 pl-3 border-l border-gray-200 space-y-1 mt-1">
                    {item.children.map((child) => {
                      const ChildIcon = child.icon;
                      return (
                        <NavLink
                          key={child.label}
                          to={child.to}
                          className={({ isActive }) =>
                            `group flex items-center gap-2.5 px-3 py-2 rounded-lg text-xs font-medium transition-colors ${isActive
                              ? "bg-gray-100 text-gray-900 font-semibold"
                              : "text-gray-500 hover:bg-gray-50 hover:text-gray-900"
                            }`
                          }
                          onClick={onClose}
                        >
                          {ChildIcon && <ChildIcon className="text-sm text-gray-400" />}
                          <span className="truncate">{child.label}</span>
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* User Profile Footer */}
        <div className="border-t border-gray-200 p-3 bg-white">
          <div className="p-2 rounded-lg bg-gray-50 border border-gray-200/80">
            <div className="flex items-center gap-3">
              <div className="relative flex-shrink-0">
                <img
                  className="w-9 h-9 rounded-lg object-cover border border-gray-200"
                  src="https://img.freepik.com/premium-photo/panda-with-green-background-white-egg-middle_950428-34761.jpg"
                  alt="User avatar"
                />
                <div className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-emerald-500 rounded-full border-2 border-white"></div>
              </div>
              {!isCollapsed && (
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5">
                    <p className="font-semibold text-xs text-gray-900 truncate">
                      {user?.name || user?.username || "Admin"}
                    </p>
                    <span className="px-1.5 py-0.5 text-[9px] font-bold rounded uppercase bg-indigo-50 text-indigo-700 border border-indigo-200 font-mono">
                      {roleDisplay}
                    </span>
                  </div>
                  <p className="text-[11px] text-gray-400 truncate mt-0.5">
                    {user?.email || "portal@taitanbet.com"}
                  </p>
                </div>
              )}
            </div>

            {!isCollapsed && (
              <button
                onClick={() => {
                  logout();
                  onClose();
                }}
                className="mt-2.5 w-full flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-lg bg-red-50 hover:bg-red-100 text-red-600 transition-colors text-xs font-medium"
              >
                <FiLogOut className="text-xs" />
                Logout
              </button>
            )}
          </div>
        </div>
      </aside>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 5px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(203, 213, 225, 0.6);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(148, 163, 184, 0.8);
        }
      `}</style>
    </>
  );
};

export default Sidebar;